export function getWeekDay(day: number) {
    switch (day) {
        case 0:
            return 'monday';
        case 1:
            return 'tuesday';
        case 2:
            return 'wednesday';
        case 3:
            return 'thursday';
        case 4:
            return 'friday';
        case 5:
            return 'saturday';
        case 6:
            return 'sunday';
        default:
            return '';
    }
}

export function translateWeekday(day: string) {
    switch (day) {
        case 'monday':
            return 'segunda-feira';
        case 'tuesday':
            return 'terça-feira';
        case 'wednesday':
            return 'quarta-feira';
        case 'thursday':
            return 'quinta-feira';
        case 'friday':
            return 'sexta-feira';
        case 'saturday':
            return 'sábado';
        case 'sunday':
            return 'domingo';
        default:
            return '';
    }
}

export const parseJwt = (token: string) => {
    var base64Url = token.split('.')[1]
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    var jsonPayload = decodeURIComponent(
        window
            .atob(base64)
            .split('')
            .map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
            })
            .join('')
    )

    return JSON.parse(jsonPayload)
}

export function secondsToHour(seconds: number){
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
}

export function capitalizeFirstLetter(input?: string): string {
    return input? input
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' '): ''
}

export const arrayMessagesConnectionTotvs = [
    'Não foi possível estabelecer uma conexão com a loja.',
    'Problemas na gravação dos itens.',
    'Mesa em digitação em outro terminal.',
    'Erro ao salvar pedido no sistema.',
    'NAO GERADO !',
]
export const arrayMessagesPaymentCard = [
    // Cielo errors
    { code: 'INVALID_CARD_NUMBER', message: 'Invalid card number', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique o número do cartão e tente novamente.' },
    { code: 'EXPIRED_CARD', message: 'Expired card', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique a data de validade do cartão e tente novamente.' },
    { code: 'INSUFFICIENT_FUNDS', message: 'Insufficient funds', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique o saldo disponível e tente novamente.' },
    { code: 'CARD_BLOCKED', message: 'Card blocked', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique se o cartão está bloqueado e tente novamente.' },
    { code: 'INVALID_SECURITY_CODE', message: 'Invalid security code', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique o código de segurança e tente novamente.' },
    { code: 'TRANSACTION_NOT_PERMITTED', message: 'Transaction not permitted', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique se a transação é permitida e tente novamente.' },
    { code: 'CARD_NOT_SUPPORTED', message: 'Card not supported', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique se o cartão é suportado e tente novamente.' },
    { code: 'TIMEOUT', message: 'Timeout', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, tente novamente.' },
    { code: 'PROCESSING_ERROR', message: 'Processing error', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, tente novamente.' },
    { code: 'FRAUD_SUSPECTED', message: 'Fraud suspected', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique os dados informados e tente novamente.' },

    // e.Rede errors
    { code: 'INVALID_CVV', message: 'Invalid CVV', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique o CVV informado e tente novamente.' },
    { code: 'CARD_EXPIRED', message: 'Card expired', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique a data de validade do cartão e tente novamente.' },
    { code: 'DO_NOT_HONOR', message: 'Do not honor', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique os dados informados e tente novamente.' },
    { code: 'LOST_CARD', message: 'Lost card', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique se o cartão está perdido e tente novamente.' },
    { code: 'STOLEN_CARD', message: 'Stolen card', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique se o cartão está roubado e tente novamente.' },
    { code: 'RESTRICTED_CARD', message: 'Restricted card', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique se o cartão está restrito e tente novamente.' },
    { code: 'AMOUNT_ERROR', message: 'Amount error', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique o valor informado e tente novamente.' },
    { code: 'INVALID_TRANSACTION', message: 'Invalid transaction', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique os dados informados e tente novamente.' },
    { code: 'ISSUER_UNAVAILABLE', message: 'Issuer unavailable', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, tente novamente mais tarde.' },
    { code: 'SYSTEM_ERROR', message: 'System error', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, tente novamente.' },
]

export type HotelAddressData = {
  cep?: string;
  street?: string;
  number?: string;
  district?: string;
  city?: string;
  state?: string;
  extra?: string;
};

export type HotelReservationContext = {
  reservationId?: number | string;
  doc?: string;
  pluginspaceId?: number | string;
  subdomain?: string;
  roomId?: number | string;
  viewOnly?: boolean;
  hotelSelectedByUser?: boolean;
  /** Quando false, webapp food (sem mesa/comanda) usa o CEP/endereco do hotel. Default: true. */
  isCepRequired?: boolean;
  /** CEP do hotel de origem (pluginspace.address.cep). */
  hotelCep?: string;
  hotelAddress?: HotelAddressData;
  guestName?: string;
  guestPhone?: string;
  roomNumber?: string;
};

export function getHotelReservationContext(): HotelReservationContext | null {
  try {
    const stored = sessionStorage.getItem("hotelReservationContext");
    if (!stored) return null;
    const parsed = JSON.parse(stored);
    return Array.isArray(parsed) ? parsed[0] : parsed;
  } catch {
    return null;
  }
}

/** isCepRequired === false: preencher e travar endereco do hotel. */
export function shouldUseHotelCep(): boolean {
  const ctx = getHotelReservationContext();
  if (!ctx) return false;
  return ctx.isCepRequired === false;
}

export function getHotelCepFromContext(): string | null {
  const ctx = getHotelReservationContext();
  const raw = ctx?.hotelCep || ctx?.hotelAddress?.cep;
  if (!raw) return null;
  const digits = String(raw).replace(/\D/g, "");
  if (digits.length !== 8) return null;
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
}

/** Interpreta o flag da API/URL; ausente ou invalido = CEP obrigatorio (comportamento atual). */
export function parseIsCepRequired(value: unknown): boolean {
  if (value === false || value === "false" || value === 0 || value === "0") {
    return false;
  }
  return true;
}

export function normalizeHotelCep(value: unknown): string | undefined {
  if (value === null || value === undefined) return undefined;
  const digits = String(value).replace(/\D/g, "");
  if (digits.length !== 8) return undefined;
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
}

export function buildHotelAddressFromLocation(location: any): HotelAddressData | undefined {
  if (!location) return undefined;
  const addr = location.address || {};
  const cep = normalizeHotelCep(location.cep || addr.cep);
  const data: HotelAddressData = {
    cep,
    street: addr.street || location.street || undefined,
    number: addr.number || location.number || undefined,
    district: addr.district || location.district || undefined,
    city: addr.city || location.city || undefined,
    state: addr.state || location.state || undefined,
    extra: addr.extra || location.extra || undefined,
  };
  if (!data.cep && !data.street && !data.city) return undefined;
  return data;
}

export function encodeHotelAddressParam(data: HotelAddressData): string {
  return window.btoa(unescape(encodeURIComponent(JSON.stringify(data))));
}

export function decodeHotelAddressParam(value: string | null): HotelAddressData | undefined {
  if (!value) return undefined;
  try {
    const json = decodeURIComponent(escape(window.atob(value)));
    const parsed = JSON.parse(json);
    if (!parsed || typeof parsed !== "object") return undefined;
    return {
      cep: normalizeHotelCep(parsed.cep),
      street: parsed.street || undefined,
      number: parsed.number != null ? String(parsed.number) : undefined,
      district: parsed.district || undefined,
      city: parsed.city || undefined,
      state: parsed.state || undefined,
      extra: parsed.extra || undefined,
    };
  } catch {
    return undefined;
  }
}

/** Prefill do ModalDelivery quando veio do hotel com CEP travado. */
export function getHotelDeliveryPrefill() {
  const ctx = getHotelReservationContext();
  if (!ctx || ctx.isCepRequired !== false) return null;

  const address = ctx.hotelAddress || {};
  const cep = getHotelCepFromContext() || address.cep || "";
  const roomNumber =
    ctx.roomNumber != null
      ? String(ctx.roomNumber)
      : ctx.roomId != null
        ? String(ctx.roomId)
        : "";

  const complementParts: string[] = [];
  if (roomNumber) complementParts.push(`Quarto ${roomNumber}`);
  if (address.extra) complementParts.push(String(address.extra));

  return {
    cep,
    state: address.state || "",
    city: address.city || "",
    district: address.district || "",
    street: address.street || "",
    number: address.number || "",
    complement: complementParts.join(" - "),
    reference: roomNumber ? `Reserva - Quarto ${roomNumber}` : "",
    name: ctx.guestName || "",
    telephone: ctx.guestPhone || "",
    roomNumber,
    locked: true as const,
  };
}
